import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import React, { use } from 'react';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'src/styling/global.scss';

import Footer from 'src/components/layout/footer';
import GlobalHeaderDesktop from 'src/components/layout/redesign/global-header-desktop';
import GlobalHeaderMobile from 'src/components/layout/redesign/global-header-mobile';
import { SiteContext } from 'src/context/site-context';

import * as styles from './global-page-layout-content.module.scss';
import { MAIN_CONTENT_ID } from './page-layout-constants';
import Snippets from './snippets';
import type { SnippetsProps } from './snippets';

type GlobalPageLayoutContentProps = PropsWithChildren<{
  snippets?: Partial<SnippetsProps>;
}>;

const GlobalPageLayoutContent: React.FC<GlobalPageLayoutContentProps> = ({
  children,
  snippets,
}) => {
  const { buildType } = use(SiteContext);

  return (
    <>
      <div className={styles.wrapper}>
        <GlobalHeaderMobile />
        <GlobalHeaderDesktop />
        <main
          id={MAIN_CONTENT_ID}
          tabIndex={-1}
          className={classNames('page-scroll', styles.pageScroll)}
          aria-label="Main content"
        >
          {children}
          <Footer />
        </main>
      </div>
      <Snippets {...snippets} buildType={buildType} />
    </>
  );
};

export default GlobalPageLayoutContent;
